import React, { createContext, useContext, useState, ReactNode } from "react";

// Định nghĩa interface cho thông tin token
interface TokenInfo {
  address: string;
  pairAddress: string;
  cursor: string;
  timeframe: string;
}

// Định nghĩa interface cho context
interface TokenContextType {
  tokenInfo: TokenInfo;
  updateTokenInfo: (newInfo: Partial<TokenInfo>) => void;
}

// Giá trị mặc định cho context
const defaultTokenInfo: TokenInfo = {
  address: "",
  pairAddress: "",
  cursor: "",
  timeframe: "",
};

// Tạo context
const TokenContext = createContext<TokenContextType>({
  tokenInfo: defaultTokenInfo,
  updateTokenInfo: () => {},
});

// Custom hook để truy cập context
export const useToken = () => {
  const context = useContext(TokenContext);
  if (!context) {
    throw new Error("useToken must be used within a TokenProvider");
  }
  return context;
};

// Provider component
export const TokenProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [tokenInfo, setTokenInfo] = useState<TokenInfo>(defaultTokenInfo);

  // Hàm để cập nhật thông tin token
  const updateTokenInfo = (newInfo: Partial<TokenInfo>) => {
    setTokenInfo((prev) => ({
      ...prev,
      ...newInfo,
    }));
  };

  return (
    <TokenContext.Provider value={{ tokenInfo, updateTokenInfo }}>
      {children}
    </TokenContext.Provider>
  );
};
